import { ComponentStyleConfig } from "@chakra-ui/react";

// Colour schemes that render as the landing page's primary (indigo) button
const brandSchemes = ["gray", "teal", "blue", "brand"];

export const ReiButton: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: "heading",
    fontWeight: 600,
    letterSpacing: "0.01em",
    borderRadius: "lg",
    transition: "all 0.2s",
  },
  variants: {
    solid: ({ colorScheme: c }) =>
      brandSchemes.includes(c)
        ? {
            bg: "brand.600",
            color: "white",
            boxShadow: "0 10px 15px -3px rgba(79, 70, 229, 0.25)",
            _hover: { bg: "brand.500", _disabled: { bg: "brand.600" } },
            _active: { bg: "brand.700" },
          }
        : {
            bg: `${c}.500`,
            color: "white",
            _hover: { bg: `${c}.600`, _disabled: { bg: `${c}.500` } },
            _active: { bg: `${c}.700` },
          },
    outline: ({ colorScheme: c }) => {
      const scheme = brandSchemes.includes(c) ? "brand" : c;
      return {
        borderWidth: "1px",
        borderColor: brandSchemes.includes(c) ? "line.DEFAULT" : `${c}.300`,
        color: `${scheme}.600`,
        bg: "white",
        _hover: { bg: `${scheme}.50`, borderColor: `${scheme}.400` },
        _active: { bg: `${scheme}.100` },
      };
    },
    unstyled: {
      color: "ink.DEFAULT",
      _hover: {
        color: "brand.600",
      },
    },
    white: {
      bg: "white",
      color: "ink.DEFAULT",
      _hover: {
        bg: "surface.low",
      },
    },
    // Soft secondary button (landing page "bg-surface-container text-primary")
    gray: {
      bg: "surface.container",
      color: "brand.600",
      _hover: {
        bg: "surface.high",
      },
    },
    custom: {
      bg: "#293040",
      color: "white",
      _hover: {
        bg: "ink.DEFAULT",
      },
    },
  },
};
